/**
 * `queryKey` is not derived from `queryParams` alone: the caller composes it (facility, filters, and a
 * mount marker), so a fresh arrival on the screen asks a new question even when the filters are
 * unchanged. `toQueryString` only serializes `queryParams`, the shape the server actually reads.
 */
class FetchFacilityWorkflowRuns {
	constructor(
		public readonly facilityId: number,
		public readonly queryParams: URLSearchParams,
		public readonly queryKey: string,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		return this.queryParams.toString();
	}
}

export default FetchFacilityWorkflowRuns;
